import React, { useState } from 'react';
import { Form, Input, Button, Checkbox } from 'antd';
import { Link } from 'react-router-dom';
import { emailDemo } from '../services/api-email';
import { useTranslation } from "react-i18next";

export default function Demo() {
  const [t, i18n] = useTranslation("global");
  const [form] = Form.useForm();
  const [error, setError] = useState('');

  const [show, setShow] = useState(false);

  const onFinish = (values) => {
    emailDemo(values)
      .then((r) => {
        setShow(true)
      })
      .catch((e) => {
        setError(e.response.data.message)
        setShow(false)
      });
      form.resetFields()
  };

  return (
    <div className="main-container">
      <div className="inner-box">
        <Form
          form={form}
          onFinish={onFinish}
          className="sign-up-form"
        >
          <Form.Item
            name="name"
            rules={[
              {
                required: true,
                message: 'Please input your Name!',
              },
            ]}
          >
            <Input placeholder={t("Demo.inputName")} />
          </Form.Item>
          <Form.Item
            name="companyName"
            rules={[
              {
                required: true,
                message: 'Please input your Company Name!',
              },
            ]}
          >
            <Input placeholder={t("Demo.inputCompany")} />
          </Form.Item>
          <Form.Item
            name="email"
            rules={[
              {
                type: 'email',
                message: 'The input is not valid E-mail!',
              },
              {
                required: true,
                message: 'Please input your E-mail!',
              },
            ]}
          >
            <Input placeholder={t("Demo.inputEmail")} />
          </Form.Item>
          <Form.Item
            name="web"
            rules={[
              {
                required: true,
                message: 'Please input your Web!',
              },
            ]}
          >
            <Input placeholder={t("Demo.inputWeb")} />
          </Form.Item>
          <Form.Item name="sector">
            <Input placeholder={t("Demo.inputSector")} />
          </Form.Item>
          <Form.Item
            name="agreement"
            valuePropName="checked"
          >
            <Checkbox>
              <spam>{t("Demo.acept")} <Link to="/politica-privacidad">{t("Demo.policity")}</Link></spam>
            </Checkbox> <br/>
              <p style={{fontSize:10}}>
              {t("Demo.messagePol")}
              <br/>
              <Link to="/aviso-legal">{t("Demo.term")}</Link>{' '}
              .</p>
          </Form.Item>
          <Button shape="round" className="btn-form" htmlType="submit">
          {t("Demo.buttonDemo")}
          </Button>
        </Form>
        <div>
          {show ? <p style={{ color: 'green', fontSize: 16, textAlign: 'center', border: 'green solid 0.5px', marginTop:5 }}>{t("Demo.sendMessage")}</p> : null}
        </div>
        <div
          style={{ fontSize: 10, marginTop: 15 }}
          className="condition-text font-fix"
        ></div>
      </div>
    </div>
  );
}
